import { createAction } from 'redux-actions'; 

export default{
    updateUser: createAction('UPDATE_USER'),
 };